import React, { useRef } from 'react';
import HeroCrumbs from 'components/Sections/Hero/HeroCrumbs';
import { ReactComponent as CalendarBlank } from 'assets/icons/CalendarBlank.svg';
import { ReactComponent as Clock } from 'assets/icons/Clock.svg';
import Tag from 'components/Tag';
import { getFormatedDate } from 'helpers';
import { selectCurrentPostIsLoading } from 'store/slices/BlogSlice';
import { useSelector } from 'react-redux';
import { useAnimation } from 'hooks/useAnimation';

const PostTitle = ({ title, tags, createdAt, readTime }) => {
    const date = getFormatedDate(createdAt);
    const loading = useSelector(selectCurrentPostIsLoading);


    const container = useRef();
    useAnimation({
        items: ['.post-title-tags', '.post-title h2', '.post-title-info'],
        container,
        dependencies: [loading],
    })

    return (
        <section ref={container} className="inner-container post-title">
            <HeroCrumbs page={title} blog={true} />
            <div className="post-title-tags">
                {tags?.data?.map(item => (
                    <Tag text={item.attributes.name} key={item.id} />
                ))}
            </div>

            <h2>{title} </h2>

            <div className="post-title-info">
                <div className="post-title-info-item">
                    <CalendarBlank />
                    {date}
                </div>
                <div className="post-title-info-item">
                    <Clock />
                    {readTime}
                </div>
            </div>
        </section>
    );
};

export default PostTitle;
